import { getAltText } from "../../../utils/safe"

const CarouselCertificazioni = ({ certificazioni, className }) => {
  if (!certificazioni?.length) {
    return null
  }

  return (
    <div className={className}>
      {certificazioni.map((certificazione) => (
        <img
          key={certificazione.id}
          src={certificazione.image.url}
          alt={getAltText(certificazione.image) || certificazione.nome}
        />
      ))}
    </div>
  )
}

export default CarouselCertificazioni